import { ref } from 'vue';

// Module-level singleton — shared across all component instances.
// Allows any page to override the breadcrumb label with a value fetched at
// runtime (e.g. an entity name from the API) instead of relying on the static
// route label. The breadcrumb component reads `dynamicTitle` reactively;
// pages should call `clearDynamicTitle` on unmount to avoid stale titles.
const dynamicTitle = ref(null);

export default function useDynamicBreadcrumb() {
  return {
    dynamicTitle,
    setDynamicTitle: (title) => { dynamicTitle.value = title; },
    clearDynamicTitle: () => { dynamicTitle.value = null; },
  };
}
